import { Color } from '@persona-id/design-tokens';
import { CircleAlertIcon } from '@persona-id/design-tokens/icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import Spacer from 'design-system/components/Spacer';
import { Paragraph } from 'design-system/components/Text';

export const ReportError = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBody>
      <Spacer height={1} />
      <CircleAlertIcon size={24} color={Color.CoreSlate400} />
      <Spacer height={1} />
      <Paragraph color='tertiary'>There has been an error while running this report:</Paragraph>
      {children}
      <Spacer height={1} />
    </ErrorBody>
  );
};

const ErrorBody = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
`;
